<template>
  <div>
    <span><checkIcon v-magicheck class="checkmark"></checkIcon></span> {{ text }}
  </div>
</template>

<script>
  import checkIcon from '../assets/checkbox.svg'
  import vivus from 'vivus'

  export default {
    name: 'checkBox',
    data() {
      return {
        timeoutPointer: false,
        anim: false
      }
    },
    props: {
      delay: {
        'type': Number,
        'default': 900
      },
      duration: {
        'type': Number,
        'default': 50
      },
      text: {
        'type': String,
        'default': 'text'
      }
    },
    mounted() {
//      let anim = new vivus(this.$el, {
//        start: 'manual', // avoid memory leak o scroll event
//        duration: this.duration,
//        animTimingFunction: vivus.EASE_IN,
//      });
//      this.anim = anim;
//      anim.reset().stop();
//      this.timeoutPointer = setTimeout(() => {
//        try {
//          anim.play();
//        } catch (e) {
//        }
//      }, this.delay);

    },
    beforeDestroy() {
//      clearTimeout(this.timeoutPointer);
//      this.anim.stop().destroy();
    },
    components: {
      checkIcon
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/checkMark.vue